module.exports = __webpack_public_path__ + "img/chevron-left.36f15b72.svg";